import Vue from 'vue';
import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from '@/store/constants';
import store from '@/store';
import {authService} from '../msal';
import jwt_decode from "jwt-decode";


export const authGuard = async (to, from, next) => {

    const fn = async () => {
        
        await authService.init();
        
        // If the user is authenticated, continue with the route
        var failoverLogin = $cookies.get('Failover-Login');

        if(failoverLogin){
            var decoded = jwt_decode(failoverLogin);
            var user = {id: decoded.UserId, email: decoded.UserEmail, name:decoded.DisplayName}
            authService.setUser(user);
        }

        if (failoverLogin || await authService.getAuthUser()) {
            await store.dispatch(CORE_PREFIX + ACTIONS.CORE.INITIALIZE_USER);
            
            return next();
        }
        // Otherwise, log in
        authService.login();
    };


    return await fn();
};
